import { trackEvent } from './trackEvent';

export const trackLink = (
    clickEvent: React.MouseEvent,
    eventName: string,
    properties: BaseTracking
) => {
    if (clickEvent.metaKey || clickEvent.ctrlKey || clickEvent.altKey || clickEvent.shiftKey) {
        trackEvent(eventName, properties);
        return;
    }

    clickEvent.preventDefault();

    trackEvent(eventName, properties);

    const href = (clickEvent.currentTarget as HTMLAnchorElement).getAttribute('href');

    if (!href) return;

    window.setTimeout(() => {
        window.location.assign(href);
    }, 300);
};
